// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__20k1a","title":"Header_title__36cxn","left":"Header_left__2RoGI","clinicName":"Header_clinicName__7_4ac"};